<div class="container">
    <!-- <button (click)="downloadPdf()" class="btn btn-primary">Download</button> -->
    <div class="book-wrapper">
        <div class="pages-container">
            <div class="pages">
                <div class="page-num-1">
                    <div class="pages-content">
                        <div class="d-flex justify-content-center">
                            <h5>{{catalogueData?.coverDetails.catalogueHeading}}</h5>
                        </div>
                        <div class="d-flex justify-content-start mt-4">
                            <p style="font-size: 12px;">{{catalogueData?.coverDetails.catalogueDes}}</p>
                        </div>
                        <div class="image-card">
                            <img src="{{catalogueData?.coverDetails.coverImg}}" alt="">
                        </div>
                    </div>
                </div>
                <ng-container *ngFor="let data of loopArray; let i = index">
                    <!-- <ng-container *ngFor="let data of catalogueData?.cataloguePageList; let i = index"> -->
                    <div class="page-num-1">
                        <div class="pages-content">
                            <div class="d-flex justify-content-between flex-wrap">
                                <ng-container *ngFor="let item of catalogueProdList[i]?.productInfo">
                                    <div class="product">
                                        <div class="prod-img" (click)="viewProduct(item._id)">
                                            <img src="{{item.images[0].src}}" alt="">
                                            <div class="overlay d-flex align-items-center justify-content-center">
                                                <span>Click to view details</span>
                                            </div>
                                        </div>
                                        <div class="prod-desc mt-1">
                                            <h6>{{item.title}}</h6>
                                            <span class="mt-1">Price: ₹{{item.maxPrice}}</span>
                                            <div class="desc mt-1" [innerHTML]="item.description" style="font-size: 10px;">
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- <div>
                                    <div class="product-wrapper">
                                        <div class="prod-img">
                                            <img src="{{catalogueData?.coverDetails.coverImg}}" alt="">
                                        </div>
                                        <div class="prod-name">
                                            <h6>Tset Product Name</h6>
                                            <span>₹499</span>
                                        </div>
                                    </div>
                                    <p class="text-muted" style="font-size: 10px;">Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry. Lorem Ipsum has been the industry's standard
                                        dummy text ever since the 1500s</p>
                                </div>
                                <div>
                                    <div class="product-wrapper">
                                        <div class="prod-img">
                                            <img src="{{catalogueData?.coverDetails.coverImg}}" alt="">
                                        </div>
                                        <div class="prod-name">
                                            <h6>Tset Product Name</h6>
                                            <span>₹499</span>
                                        </div>
                                    </div>
                                    <p class="text-muted" style="font-size: 10px;">Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry. Lorem Ipsum has been the industry's standard
                                        dummy text ever since the 1500s</p>
                                </div> -->
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="loopArray.length%2" class="page-num-1">
                    <div class="pages-content"></div>
                </div>
                <div class="page-num-1">
                    <div class="pages-content">
                        <div class="d-flex justify-content-center">
                            <h5>{{catalogueData?.endingDetails.endingHeading}}</h5>
                        </div>
                        <div class="d-flex justify-content-center mt-4">
                            <p style="font-size: 12px;">{{catalogueData?.endingDetails.endingDes}}</p>
                        </div>
                        <div class="image-card">
                            <img src="{{catalogueData?.endingDetails.endingImg}}" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>